import React from 'react';
import SectionOne from './SectionOne/index.jsx';

export class IndustryComponent extends React.Component {

    componentDidMount() {
        window.scrollTo(0,0)
    }


    render() {
        return (
            <React.Fragment>
                <section>
                    <SectionOne  />
                </section>
            </React.Fragment>
        );
    }
}

export default IndustryComponent;
